// extracted by mini-css-extract-plugin
module.exports = {"component":"calendar-offer-icon_component__D7Q6t"};